<template>
  <div class="magazines-client">
    <div
      class="container-fluid page-header"
      :style="{ backgroundImage: 'url(' + require('@/assets/landing_page/buildings.jpg') +')' }"
    >
      <div class="row">
        <div class="col-12">
          <div class="page-title">Revistas Online</div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-12" v-for="magazine in client.magazines" v-bind:key="magazine.id">
          <div class="card cardMagazine">
            <div class="card-body">
              <div>

                <router-link
                  class="primary-a"
                  :to="{ name: 'public.magazine-editions', params:{id: magazine.id} }"
                >
                  <img class="magazine" v-bind:src="magazine.cover_url" />
                  <label class="title">{{magazine.name}}</label>
                </router-link>

              </div>
              <div style="margin-bottom:30px !important">
                <label class="content">{{limitText(magazine.description, 100)}}</label>
              </div>
              <div>
                <div class="logo">
                  <hr class="hr" />
                  <img class="governetLogo" src="@/assets/landing_page/logo_g.png" alt />
                  <label class="governetTitle">Governet</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import helper from "@/imports/Helpers";

export default {
  name: "client",
  components: {},
  data() {
    return {
      client: {
        magazines: []
      }
    };
  },
  mounted() {
    helper.getClientUserPermissions().then(data => {
      this.client = data;
    });
  },
  methods: {
    limitText: function(text, limit) {
      return helper.limitText(text, limit);
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/General.scss";
.magazines-client{
  padding-bottom: 4vh;
  .magazine {
    margin-left: auto;
    margin-right: auto;
    display: block;
    width: 150px;
    padding-bottom: 20px;
  }
  .title {
    color: #1f1f1f;
    font-weight: bold;
  }
  .hr {
    width: 100%;
    border-top: 1px solid rgb(224, 221, 221);
  }
  .content {
    color: grey;
    margin-top: 10px;
    margin-bottom: 20px;
  }
  .logo {
    font-size: 14px;
    width: calc(100% - 3vw);
    color: #5f6064;
    position: absolute;
    bottom: 1vw;
    i {
      margin-right: 5px;
    }
  }
  .governetTitle {
    color: #1f1f1f;
    font-weight: bold;
    margin: 0;
    text-align: center;
    padding: 5px;
  }
  .governetLogo {
    width: 30px;
    margin-top: auto;
    margin-bottom: auto;
  }
  .cardMagazine {
    padding: 10px;
    padding-bottom: 5px !important;
    margin-bottom: 5px;
    height: 100%;
  
    position: relative;
    min-height: 35vh !important;
  }
  .gray-border {
    border-top: 1px solid rgb(224, 221, 221) !important;
    width: 100%;
    position: flex;
  }
  .outSideDiv {
    margin: 5px;
    padding: 10px;
    text-align: center;
  }
}
</style>